// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

import { endpoints } from "../api/endpoints";
import authAxios from "./_shared/authAxios";

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const startWidrawalProcess = createAsyncThunk(
  "withdrawal/startWidrawalProcess",
  async ({ withdrawalId }, { rejectWithValue }) => {
    try {
      const response = await authAxios({
        url: endpoints.withdrawal.withdrawal,
        method: "POST",
        data: { withdrawal_id: withdrawalId },
      });

      if (response.data && response.data.status === 0) {
        return { data: response.data, success: true };
      }

      return rejectWithValue({
        message: response.data.message
      });
    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
);

export const doCashout = createAsyncThunk(
  "withdrawal/doCashout",
  async ({ withdrawalId, validationCode }, { rejectWithValue }) => {
    try {
      const response = await authAxios({
        url: endpoints.withdrawal.cashout,
        method: "POST",
        data: {
          withdrawal_id: withdrawalId,
          validation_code: validationCode,
        },
      });
      if (response.data && response.data.status === 0) {
        return { data: response.data, success: true };
      }

      return rejectWithValue({
        message: response.data.message
      });

    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
);

export const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState: {
    withdrawalInProgress: false,
    withdrawalResult: null,
    withdrawalError: null,
    cashoutInProgress: false,
    cashoutResult: null,
    cashoutError: null,
  },
  reducers: {
    resetWithdrawalState: (state) => {
      state.withdrawalInProgress = false;
      state.withdrawalResult = null;
      state.withdrawalError = null;
      state.cashoutInProgress = false;
      state.cashoutResult = null;
      state.cashoutError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(startWidrawalProcess.fulfilled, (state, action) => {
        state.withdrawalInProgress = false;
        state.withdrawalResult = action.payload;
      })
      .addCase(startWidrawalProcess.pending, (state) => {
        state.withdrawalInProgress = true;
        state.withdrawalResult = null;
        state.withdrawalError = null;
        state.cashoutInProgress = false;
        state.cashoutResult = null;
        state.cashoutError = null;
      })
      .addCase(startWidrawalProcess.rejected, (state, action) => {
        state.withdrawalInProgress = false;
        state.withdrawalError = action.payload;
      })
      .addCase(doCashout.fulfilled, (state, action) => {
        state.cashoutInProgress = false;
        state.cashoutResult = action.payload;
      })
      .addCase(doCashout.pending, (state) => {
        state.cashoutInProgress = true;
        state.cashoutError = null;
      })
      .addCase(doCashout.rejected, (state, action) => {
        state.cashoutInProgress = false;
        state.cashoutError = action.payload;
      });
  }
});

export const { resetWithdrawalState } = withdrawalSlice.actions;

export default withdrawalSlice.reducer;
